import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { AuBankAccountElement } from '@stripe/react-stripe-js';
import get from 'lodash.get';
import { withStripe } from './withStripe';

import { setPaymentStarted, makePaymentErrorOccured, onValueChange, makeRecurringBankAccountPaymentRequest } from '../reducer';
import { DeviceHelper } from '../../../helpers/deviceHelper';
import { getMappedAddress } from '../../../helpers/formBuilderHelper';

import { Form } from 'semantic-ui-react';
import DonationErrorMessage from './donationErrorMessage';
import DonateButton from './donationButton';
import CoverFee from './coverFee';
import { InjectReCaptcha } from '../../../components/common/reCaptcha';
import BankAccount from './bankAccount';

import { loadingStatus } from '../../../constants/loading';
import { MAX_BANK_ACCOUNT_DONATION_VALUE } from '../../../constants';
import { erorrMessages } from '../constants/errorMessages';
import { salutationTypes } from '../../../constants/salutation';
import { RECAPTCHA_SITE_KEY } from '../../../env';
import { donationRecurringFrequency } from '../../../constants/recurring';

import './index.css';

export class RecurringBankAccountPaymentFormContainer extends React.Component {
    componentDidUpdate() {
        if (this.props.donation.paymentInProgress === loadingStatus.SUCCESS) {
            if (this.props.match.url.endsWith('/')) {
                this.props.history.push(`${this.props.match.url}thankyou`);
            } else {
                this.props.history.push(`${this.props.match.url}/thankyou`);
            }
        }
    }

    handleSubmit = (ev) => {
        const win = window;

        if (RECAPTCHA_SITE_KEY && win.grecaptcha) {
            win.grecaptcha.ready(_ => {
                win.grecaptcha
                    .execute(RECAPTCHA_SITE_KEY, { action: "subscribe" })
                    .then(token => {
                        this.proceedSubmit(ev, token);
                    })
            })
        }
        else {
            this.proceedSubmit(ev);
        }
    }

    proceedSubmit = (ev, verificationToken = null) => {
        this.props.setPaymentStarted();

        // We don't want to let default form submission happen here, which would refresh the page.
        ev.preventDefault();

        this.submitPayment(verificationToken);
    };

    paymentConfirm = (intentPublicKey) => {
        return this.props.stripe.confirmAuBecsDebitSetup(
            intentPublicKey,
            {
                payment_method: {
                    au_becs_debit: this.props.elements.getElement(AuBankAccountElement),
                    billing_details: {
                        name: `${this.props.donation.customer.firstName} ${this.props.donation.customer.lastName}`,
                        email: this.props.donation.customer.email
                    }
                }
            })
    }

    // TODO: unit test this method, it shouldn't crash in any case
    submitPayment = (verificationToken) => {
        const donation = {
            amount: this.props.donation.amount,
            frequency: donationRecurringFrequency.monthly,
            payment: {
                creditCard: null,
                coverFee: this.props.donation.coverProcessingFee,
                isIntent: true
            },
            pageType: 1,
            organizationId: get(this.props, 'page.organization.id'),
            campaignId: get(this.props, 'page.campaign.id'),
            device: {
                type: DeviceHelper.getDeviceType(),
                platform: DeviceHelper.getDevicePlatform()
            },
            donor: {
                salutation: this.props.donation.customer.salutation !== salutationTypes.None ? this.props.donation.customer.salutation : null,
                email: this.props.donation.customer.email,
                firstName: this.props.donation.customer.firstName,
                lastName: this.props.donation.customer.lastName,
                businessName: this.props.donation.customer.isBehalfOfCompany ? this.props.donation.customer.businessName : null,
                newsletter: this.props.donation.customer.newsletter,
                phoneNumber: this.props.donation.phoneNumber,
                address: getMappedAddress(this.props.donation.address)
            },
            issueReceipt: true
        };
        this.props.makePayment(donation, this.props.donation.idempotencyKey, this.paymentConfirm.bind(this), verificationToken);
    };

    isTooMuchValue = () => {
        return get(this.props, 'donation.amount') > MAX_BANK_ACCOUNT_DONATION_VALUE;
    };

    render() {
        const isTooMuchValue = this.isTooMuchValue();
        const donationAmount = get(this.props, 'donation.amount');
        const organizationLegalName = get(this.props, 'page.organization.legalName') || "";
        const organizationTaxId = get(this.props, 'page.organization.taxId') || "";

        return (
            <Form id="payment-form" onSubmit={this.handleSubmit}>
                <Form.Field>
                    <BankAccount />
                </Form.Field>
                <Form.Field>
                    <CoverFee amount={donationAmount} />
                </Form.Field>
                <div className="bank-account-terms-and-conditions">
                    <span>{`By providing your bank account details and confirming this payment, you agree to this Direct Debit Request and the `}</span>
                    {/* eslint-disable-next-line*/}
                    <a href="https://stripe.com/au-becs-dd-service-agreement/legal" target="_blank">{`Direct Debit Request service agreement`}</a>
                    {/* eslint-disable-next-line*/}
                    <span>{`, and authorise Stripe Payments Australia Pty Ltd ACN 160 180 343 Direct Debit User ID number 507156 (\"Stripe\") to debit your account through the Bulk Electronic Clearing System (BECS) on behalf of GRASS ROOTS COMPANY PTY LTD (the \"Merchant\"), operating on behalf of ${organizationLegalName.toUpperCase()} (ABN/ACN ${organizationTaxId}) for any amounts separately communicated to you by the Merchant. You certify that you are either an account holder or an authorised signatory on the account listed above.`}</span>
                </div>
                <DonateButton disabled={isTooMuchValue} />
                {
                    isTooMuchValue &&
                    <DonationErrorMessage dismiss={false}
                        errorMessage={erorrMessages.MaxBankAccountValueError} />
                }

                {
                    this.props.donation.serverErrorOccured &&
                    <DonationErrorMessage dismiss={true}
                        errorMessage={erorrMessages.ProcessingError} />
                }
            </Form>
        );
    }
}

const mapState = state => {
    return {
        donation: state.donation,
        page: state.page
    };
};

const mapDispatch = dispatch => {
    return {
        onValueChange(path, value) {
            dispatch(onValueChange(path, value));
        },
        makePayment: (donation, idempotencyKey, confirmCallback, verificationToken) => {
            dispatch(makeRecurringBankAccountPaymentRequest(donation, idempotencyKey, confirmCallback, verificationToken));
        },
        setPaymentStarted: () => {
            dispatch(setPaymentStarted());
        },
        makePaymentErrorOccured: error => {
            dispatch(makePaymentErrorOccured(error));
        }
    };
};

const RecurringBankAccountMakePaymentForm = withRouter(
    connect(mapState, mapDispatch)(InjectReCaptcha(withStripe(RecurringBankAccountPaymentFormContainer)))
);

export default RecurringBankAccountMakePaymentForm;

